import { Expose } from "class-transformer";

export class UpdateBusinessLineDto {
  @Expose()
  id: string;

  @Expose()
  name: string;
}
